import { ExtendedTypography } from '@issuemanager/apps/client/components';
import { useAtlasSemanticThemeTokens } from '@issuemanager/apps/client/theme';
import { Stack } from '@mui/material';
import React from 'react';

interface Props {
  label: string;
  children?: React.ReactNode;
}

export function QuickFilterContainer({ label, children }: Props) {
  const semantic = useAtlasSemanticThemeTokens();

  return (
    <Stack data-testid={label.toLowerCase().replace(/\s+/g, '-')}>
      <ExtendedTypography
        variant='label'
        fontWeight={semantic.fontWeight.emphasis.value}
        color={semantic.color.text.body.value}
        marginBottom={2}
        textAlign='left'
      >
        {label}
      </ExtendedTypography>

      <Stack direction='row' gap={4} rowGap={0} flexWrap='wrap'>
        {children}
      </Stack>
    </Stack>
  );
}
